import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import Wordcloud from 'highcharts/modules/wordcloud';

interface WordData {
	id: string;
	name: string;
	count: number;
}

@Component({
	selector: 'portals-word-cloud',
	templateUrl: './portals-word-cloud.component.html',
	styleUrls: ['./portals-word-cloud.component.scss'],
})
export class PortalsWordCloudComponent implements OnChanges, OnDestroy {
	@Input() data: { counter: number; words: WordData[]; autorefresh: boolean } = { counter: 0, words: [], autorefresh: false };
	@Output() toggleAnimation = new EventEmitter<boolean>();
	autoRefresh = false;
	chart: Highcharts.Chart | undefined;
	counter = 0;
	isExpanded = false;
	private intervalTimeOut: NodeJS.Timeout | undefined;
	private bufferTimeOut: NodeJS.Timeout | undefined;
	private expandTimeout: NodeJS.Timeout | undefined;
	private updating = false;
	private queuedChange = false;
	constructor(public cdr: ChangeDetectorRef) {
		// this.autoRefresh = false;
	}
	ngOnDestroy() {
		if (this.intervalTimeOut) {
			clearInterval(this.intervalTimeOut);
		}

		if (this.bufferTimeOut) {
			clearInterval(this.bufferTimeOut);
		}
	}
	ngOnChanges(changes: SimpleChanges): void {
		this.cdr.detectChanges();

		if (changes['data']) {
			const currentValue = changes['data'].currentValue;
			if (this.autoRefresh !== currentValue.autorefresh) {
				this.autoRefresh = currentValue.autorefresh;
			}
			this.updateWordCloud();
		}
	}

	public updateWordCloud(fromMQTT = true): void {
		if (fromMQTT) {
			if (this.intervalTimeOut) {
				clearInterval(this.intervalTimeOut);
				this.startUpdateInterval();
			}
			if (this.expandTimeout && this.isExpanded) {
				clearInterval(this.expandTimeout);
				this.toggleAnimation.emit(false);
				this.isExpanded = false;
			}
		}

		if (!this.updating) {
			this.updating = true;
			const totalCount = this.data.words.reduce((acc, item) => acc + Number(item.count), 0);
			const formattedData = this.data.words.map((item) => ({
				id: item.id,
				name: item.name,
				weight: (item.count / totalCount) * 100 + Math.random() * 0.001,
				count: item.count,
			}));

			if (this.chart) {
				this.chart.series[0].setData(formattedData);
			} else {
				this.initializeWordCloud(formattedData);
			}

			if (fromMQTT)
				this.bufferTimeOut = setTimeout(() => {
					this.updating = false;
					this.bufferTimeOut = undefined;
					if (this.queuedChange) {
						this.updateWordCloud();
						this.queuedChange = false;
					}
				}, 5000);
			else {
				this.updating = false;
				this.bufferTimeOut = undefined;
			}
		} else if (fromMQTT) {
			this.queuedChange = true;
		}
	}

	private initializeWordCloud(data: any[]): void {
		Wordcloud(Highcharts); // Initialize word cloud module
		const options: Highcharts.Options = {
			chart: {
				type: 'wordcloud',
				renderTo: 'wordCloudContainer',
			},
			colors: ['#B18FCF', '#D66853', '#357266', '#A31621'],
			credits: {
				enabled: false,
			},
			series: [
				{
					type: 'wordcloud',
					data: data,
					name: 'Occurrences',
				},
			],
			title: {
				text: '',
			},
			tooltip: {
				enabled: false
			},
		};

		this.chart = Highcharts.chart(options);
		// Start the interval process
		this.startUpdateInterval();
	}

	startUpdateInterval() {
		const getRandomInterval = () => {
			const randomInterval = Math.floor(Math.random() * 1000) + 5000; // random interval between 1000 and 2000 ms
			return this.isExpanded ? Math.max(randomInterval, 18000) : randomInterval;
		};

		this.intervalTimeOut = setTimeout(() => {
			if (this.counter && !(this.counter % 4) && !this.isExpanded) {
				this.counter++;
				// this.toggleAnimation.emit(true);
				// this.isExpanded = true;


				this.expandTimeout = setTimeout(() => {
					if (this.isExpanded) {
						this.toggleAnimation.emit(false);
						this.isExpanded = false;
					}
				}, 12400);
			} else if (!this.isExpanded) {
				if (this.autoRefresh) {
					this.counter++;
					this.updateWordCloud(false);
				}
			}
			this.startUpdateInterval();
		}, getRandomInterval());
	}
}
